import { Box } from "@twilio-paste/core/box";
import { type ThemeShape } from "@twilio-paste/core/theme";
import { type ValidIsoCode2 } from "../../definitions/countries";

type SpaceOptions = keyof ThemeShape["space"];
type SizeOptions = keyof ThemeShape["iconSizes"];

export interface FlagIconProps {
  country: ValidIsoCode2;
  marginRight?: SpaceOptions;
  size?: SizeOptions;
}

// https://cdn.jsdelivr.net/npm/svg-country-flags@1.2.10/svg/
const FLAG_CDN_BASE_URL =
  "https://cdn.jsdelivr.net/npm/flag-icon-css@3.5.0/flags/4x3/";

const FlagIcon = ({
  country,
  size = "sizeIcon40",
  marginRight = "space30",
}: FlagIconProps) => {
  const svgFlag = `${FLAG_CDN_BASE_URL}${country.toLowerCase()}.svg`;

  return <Box as="img" src={svgFlag} size={size} marginRight={marginRight} />;
};

export default FlagIcon;
